/**
 * Takes an array of ProgramDesignations and returns an object that maps each program designation
 * id to its name.
 */
export const getProgramDesignationLabels = designations => designations.reduce((acc, programDesignation) => {
  acc[programDesignation.id] = programDesignation.name;
  return acc;
}, {});